<template>
	<div class="nav-section">
		<el-row class="nav" justify="space-between" align="middle">
			<div class="left">
				<!-- 折叠 -->
				<el-icon class="pointer" v-if="isCollapse" @click="collapseClick('close')"><Fold /></el-icon>
				<!-- 展开 -->
				<el-icon class="pointer" v-else @click="collapseClick('open')"><Expand /></el-icon>
			</div>
			<div class="right flex">
				<div class="yddbtn pointer" @click="$router.push('/personal')">
					<img :src="avatar" alt="" class="pic" v-if="avatar && avatar != null">
					<img src="@/static/icon.png" alt="" class="pic" v-else>
					{{account}}
				</div>
				<div class="yddbtn pointer" @click="toLogout">
					<el-icon><SwitchButton /></el-icon>退出
				</div>
			</div>
		</el-row>
	</div>
</template>

<script lang="ts" setup>
	import { getCurrentInstance } from "vue"
	import { useModuleMapState } from '@/config/useMapState'
	import { useStore } from 'vuex'
	import { localDel } from '@/config/storage'
	import { signOut } from '@/request/api/auth'
	
	const {commit} = useStore()
	
	const { isCollapse, account, avatar } = useModuleMapState('publicOptions', ['isCollapse', 'account', 'avatar'])
	const collapseClick = (state:string) => {
		switch (state) {
			case 'open':
				commit("publicOptions/MENU_COLLAPSE", true)
		    break
			case 'close':
				commit("publicOptions/MENU_COLLAPSE", false)
		    break
		}
	}
	const {$confirm, $message, $router} = getCurrentInstance().appContext.config.globalProperties
	const toLogout = () => {
		$confirm('是否退出登录?', '系统提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
		  try {
		    const { code, message } = await signOut()
		    if (code === 200) {
		      $message.success(message)
		      commit("publicOptions/SAVE_TOKEN", '') //删除vuex中的token
		      localDel('token')
			  commit("publicOptions/SAVE_AVATAR", '') //删除vuex中的token
			  localDel('avatar')
		      $router.replace('/login')
		    }
		  } catch (error) {
		    console.log(error)
		  }
		}).catch(() => {
			
		})
	}
</script>

<style scoped lang="scss">
	.nav{
		height: 50px;
		padding: 0 20px;
		background-color: #fff;
	}
	.yddbtn{
		line-height: 34px;
		font-size: 14px;
		&+.yddbtn{
			margin-left: 30px;
		}
		img{
			width: 34px;
			height: 34px;
			display: inline-block;
			vertical-align: middle;
			margin-right: 5px;
			border-radius: 50%;
		}
		.el-icon{
			font-size: 16px;
			margin-right: 5px;
			vertical-align: middle;
			margin-top: -3px;
		}
	}
</style>